import React, { FC, useMemo } from "react";
import { Page } from "shared/ui";
import { useModal } from "shared/hooks";
import { useGetAllMachinesWithNoParamsQuery } from "shared/api";
import { ProductionAnalysisTable, ExportCSVModal } from "./ui";

const ProductionAnalysis: FC = () => {
  const [isExportModalOpen, showExportModal, hideExportModal] = useModal();

  const { data: machines } = useGetAllMachinesWithNoParamsQuery();

  const adaptedMachines = useMemo(() => {
    return (
      machines?.map((machine) => ({
        label: machine.name,
        value: machine.id,
      })) || []
    );
  }, [machines]);

  return (
    <Page
      title="Production Analysis"
      buttonTitle="Export CSV"
      onClick={showExportModal}
    >
      <ProductionAnalysisTable />

      <ExportCSVModal
        isOpen={isExportModalOpen}
        onClose={hideExportModal}
        machines={adaptedMachines}
      />
    </Page>
  );
};

export { ProductionAnalysis };
